import React, { Component } from 'react';
import TimeSlider from './slider'
import logo from '../logo.png';
import Web3 from 'web3'
import './App.css';
import {ByteBeat, ByteBeatEngine} from './Bytebeat'


// import ERC721 from '../abis/ERC721.json'
import GenArt721 from '../abis/GenArt721.json'


class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: '',
      contract: null,
      totalSupply: 0,
      //iframeskey: "value",  [],
      canvases: [],
      thumbnails: [],
      bytebeats: [],
      current_bytebeat: {},
      stage: "disconnected",
      token_hashes: [],
      loading_animation_frame: 0,
      loading_animation_interval: 0
    }
    this.bytebeat_engine = new ByteBeatEngine();
    console.log(this.bytebeat_engine)
    //this.bytebeat_engine.playpause()
  }

  animateLoading = () => {
    this.setState({"loading_animation_frame": (this.state.loading_animation_frame+1)%5})
  }
  componentDidMount(){
    if(this.state.loading_animation_interval) clearInterval(this.state.loading_animation_interval);
    this.setState({"loading_animation_interval": setInterval(this.animateLoading, 50)});

  }
  componentWillUnmount(){
    if(this.state.loading_animation_interval) clearInterval(this.state.loading_animation_interval);

  }


  async loadWeb3() {
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum)
      await window.ethereum.enable()
    }
    else if (window.web3) {
      window.web3 = new Web3(window.web3.currentProvider)
    }
    else {
      window.alert('Non-Ethereum browser detected. You should consider trying MetaMask!')
    }
  }
  async connectToMetamask() {
    this.setState({"stage":"loading"})
    await this.loadWeb3()
    this.loadBlockchainData()
  }


  async loadBlockchainData() {
    const web3 = window.web3
    // Load account
    const accounts = await web3.eth.getAccounts()
    let account = accounts[0]
    //account = "0xf3860788D1597cecF938424bAABe976FaC87dC26";
    this.setState({ account: account })

    const networkId = await web3.eth.net.getId()
    const networkType = await web3.eth.net.getNetworkType();

    console.log(networkId, networkType, accounts);

    var tokenContractAddress;
    var artblocksGeneratorUrl;
    var byteBeatsProjectId;
    if(networkType=="rinkeby"){
      artblocksGeneratorUrl = "https://rinkebyapi.artblocks.io/generator/"
      tokenContractAddress = "0x152eee3dcc5526efd646e9b45c9a9672bffcc097"
      byteBeatsProjectId = 9;
    }else if(networkType=="main"){
      artblocksGeneratorUrl = "https://api.artblocks.io/generator/"
      tokenContractAddress = "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270"
      byteBeatsProjectId = 38;
    }else{
      alert("Please connect Metamask to either the main ethereum network, or the rinkeby test network.")
      return;
    }

    const contract = web3.eth.Contract(GenArt721, tokenContractAddress)
    // Okay at this point we have successfully connected
    window.contract = contract
    this.setState({"contract": contract})

    /*let project_details = await contract.methods.projectDetails(project_id).call()
    console.log(project_details)
    let project_token_info = await contract.methods.projectTokenInfo(project_id).call()
    console.log(project_token_info)
    let project_script_info = await contract.methods.projectScriptInfo(project_id).call()
    console.log(project_script_info)
    let project_all_tokens = await contract.methods.projectShowAllTokens(project_id).call()
    console.log(project_all_tokens)*/
    //let totalSupply = await contract.methods.symbol().call()
    //console.log(totalSupply)

    /*let balance = parseInt(await contract.methods.balanceOf(account).call())
    console.log(balance)
    
    
    for(let i=0; i<balance; i++){*/
    //let iframes = []
    let canvases = []
    let bytebeats = []
    let token_hashes = [];
    let thumbnails = [];
    let tokens_of_owner = await contract.methods.tokensOfOwner(account).call();


    // one canvas
    let canvas_id = "the-one-canvas";
    let canvas = <canvas id={canvas_id} key={Math.random()} width={256} height={256} />      
    canvases.push(canvas)

    this.setState({ canvases })
    let canvas_element = document.getElementById(canvas_id)
    canvas_element.addEventListener('click', ()=>{this.clickCanvas()});



    console.log(tokens_of_owner);
    for(let i in tokens_of_owner){
      /*if(i == 5){
        continue;
      }*/
      let token_id = parseInt(tokens_of_owner[i]);
      //let token_id = parseInt(await contract.methods.tokenOfOwnerByIndex(account, i).call())
      let project_id = parseInt(await contract.methods.tokenIdToProjectId(token_id).call())
      if(project_id!=byteBeatsProjectId){
        continue;
      }
      // Found a bytebeats token!
      let token_hash = await contract.methods.tokenIdToHash(token_id).call()
      console.log(token_id, token_hash)
      token_hashes.push(token_hash)
      this.setState({ token_hashes })

      // old way: load artblocks iframe
      //let url = artblocksGeneratorUrl + token_id;
      //console.log(url)
      //let key = "artblock"+token_id
      //iframes.push(<iframe src={url} key={key} title="Project Live View"></iframe>)

      // new way: make canvases
      /*
      let canvas = <canvas id={token_hash} key={token_hash} width={256} height={256} />      
      canvases.push(canvas)
      this.setState({ canvases })

     
      let canvas_element = document.getElementById(token_hash)

      //console.log(canvas, canvas_element)

      let bytebeat = new ByteBeat(token_hash, canvas_element)
      canvas_element.addEventListener('click', ()=>{this.clickCanvas(bytebeat)});
      //console.log(bytebeat)
      bytebeats.push(bytebeat)
      this.bytebeat_engine.all_vizsquares.push(bytebeat.viz_square)

      this.setState({bytebeats, thumbnails})
      */

      // newer way: one canvas
      let bytebeat = new ByteBeat(token_hash, canvas_element)
      //canvas_element.addEventListener('click', ()=>{this.clickCanvas()});
      bytebeats.push(bytebeat)
      //this.bytebeat_engine.all_vizsquares.push(bytebeat.viz_square)
      this.setState({bytebeats, thumbnails})
      let thumbnail = this.make_thumbnail(token_id, bytebeat);
      thumbnails.push(thumbnail)

    }
    if(tokens_of_owner.length>0){
      this.updateByteBeat(this.state.bytebeats[0])
    }

    /*while(canvases.length<4 || canvases.length%2==1){
      canvases.push(<div key={Math.random()} className="missing-bytebeat"><div></div></div>)
    }*/
    while(thumbnails.length<4 || thumbnails.length%4!=0){
      thumbnails.push(<div key={Math.random()} className="missing-bytebeat_thumbnail"><div></div></div>)
    }
    this.setState({ canvases, "stage":"connected" })
    //this.bytebeat_engine.all_vizsquares = [this.state.bytebeats[0].viz_square]


    //console.log(contract.balanceOf( account, function(err,ok) { console.log(err,ok.c[0]) } ))




    /*
    const networkData = ByteBeats.networks[networkId]
    if(networkData) {
      const abi = ByteBeats.abi
      const address = networkData.address
      const contract = new web3.eth.Contract(abi, address)
      this.setState({ contract })
      const totalSupply = await contract.methods.totalSupply().call()
      this.setState({ totalSupply })
      // Load Colors
      for (var i = 1; i <= totalSupply; i++) {
        const color = await contract.methods.colors(i - 1).call()
        this.setState({
          colors: [...this.state.colors, color]
        })
      }
    } else {
      window.alert('Smart contract not deployed to detected network.')
    }*/
  }

  /*clickCanvas(bytebeat){
    if(bytebeat!=this.state.current_bytebeat){
      this.updateByteBeat(bytebeat)  
    }else{
      this.bytebeat_engine.playpause()
    }
  }*/
  clickCanvas(){
    console.log("hi");
    this.bytebeat_engine.playpause()
  }

  updateByteBeat(bytebeat){
    this.setState({
      current_bytebeat: bytebeat,
    })
    this.bytebeat_engine.change_bytebeat(bytebeat);
    if(this.bytebeat_engine.playing == false){
      this.bytebeat_engine.playpause()
    }
  }
  // playhead has been moved, is measured in esconds
  update_seconds(seconds){
    if(this.bytebeat_engine && this.bytebeat_engine.bytebeat){
      //console.log("update_seconds", this.bytebeat_engine.current_time, seconds)
      // calculate t (sample number) from seconds
      this.bytebeat_engine.skip_to(seconds)
    }
  }
  make_thumbnail(token_id, bytebeat){
    let url = "https://mainthumb.oss.nodechef.com/"+token_id+".png"
    return <div className="bytebeat_thumbnail">
        <img key={"thumb_"+token_id} src={url} onClick={()=>this.updateByteBeat(bytebeat)}/>
      </div>
  }

  time_hex(){
    let t = 0
    if(this.bytebeat_engine && this.bytebeat_engine.bytebeat){
      t = this.bytebeat_engine.get_sample_index();
    }
    let hex = t.toString(16);
    hex = "0x" + ("00000000000000"+hex).slice(-14)
    return hex;
  }
  time_text(){
    if(this.bytebeat_engine && this.bytebeat_engine.bytebeat){
      let s = this.bytebeat_engine.get_seconds();
      //console.log(s)
      let seconds = (s%60);
      let minutes = (s/60);
      let hours = (s/60/60);
      let days = (s/60/60/24);
      let years = (s/60/60/24/365);

      let timecode = "";
      timecode = ("0"+Math.floor(seconds)%60).slice(-2);
      timecode = ("0"+Math.floor(minutes)%60).slice(-2) + ":" + timecode;
      if(hours>1 && days<1){
        timecode = (""+Math.floor(hours)%24).slice(-2) + ":" + timecode;
        //timecode = timecode + " " + ("0"+Math.floor(hours)%24).slice(-2) + " hours " 
      }else if(hours>1 && days>=1){
        timecode = ("0"+Math.floor(hours)%24).slice(-2) + ":" + timecode;
        //timecode = timecode + " " + ("0"+Math.floor(hours)%24).slice(-2) + " hours " 
      }
      if(days>1 && years<1){
        timecode = timecode + " " + (""+Math.floor(days)%356).slice(-3) + " days " 
      }else if(days>1 && years>=1){
        timecode = timecode + " " + ("00"+Math.floor(days)%356).slice(-3) + " days " 
      }
      if(years>=1){
        timecode = timecode + " " + Math.floor(years) + " years ";
      }
      return timecode
    }else{
      return ""
    }
  }
    
  //♩ ♪ ♫ ♬ ♭ ♮ ♯



  render() {
    let elipsis = Array(this.state.loading_animation_frame).fill(" .").join("")
    let loadingText = elipsis + " loading"  + elipsis
    let timeText = this.time_text();
    let timeHex = this.time_hex();
    let bytebeatCode = "";
    let canvas = <div id="canvases">
                <canvas id={"the-one-canvas"} key={Math.random()} width={256} height={256} /> 
              </div>
    if(this.state.current_bytebeat && this.state.current_bytebeat.data){
      bytebeatCode = this.state.current_bytebeat.data.original_code;
      bytebeatCode = <h3 className="bytebeat_code">{bytebeatCode}</h3>

    }
    return (
      <div className="container">
        {this.state.stage == "disconnected" && <div>
          <img src="logo2.gif" className="noselect"/>
          <h3 className="loadcollection">Load your collection</h3>
          <div><button className="button loadcollection" onClick={()=>this.connectToMetamask()}>CONNECT TO METAMASK</button></div>
          <p className="description">Generative music in 40-140 bytes on-chain. ByteBeats are miniature functions that synthesize audio (and video) via bitwise operations (&amp;^|&lt;&lt;*+/%&gt;&gt;). Because bits form groups in powers of 2, 4/4 beat-driven music emergently self-organizes. Each function in this drop is itself randomly generated, grouped into six families of composition and four families of visualizers. Some ByteBeats loop, some generate new patterns indefinitely. Some are for headbanging, some are for climbing forever through oceans of phase cancelation.</p>
          <h4>Standing on the Shoulders of Giants</h4>
          <p className="description">This style of algorithmic music composition was first popularized by <a target="_blank" href="http://countercomplex.blogspot.com/2011/10/algorithmic-symphonies-from-one-line-of.html">Viznut</a> with a series of videos. <a target="_blank" href="https://secure.flickr.com/photos/kylemcdonald/6198297132/in/set-72157627762378810/">Kyle McDonald</a> was an early pioneer in visualizing the structure of these functions as bitmap images. Definitely check out their work. Today people run ByteBeat <a target="_blank" href="https://battleofthebits.org/lyceum/View/bytebeat1k%20(format)">competitions</a> and post on <a target="_blank" href="https://www.reddit.com/r/bytebeat">/r/bytebeat</a>. Try composing your own using this <a target="_blank" href="https://greggman.com/downloads/examples/html5bytebeat/html5bytebeat.html">web tool</a></p>
          <h4>Trying Not To Fuck Up The Environment</h4>
          <p className="description">Artblocks runs on Ethereum 1.0 which like Bitcoin is a total energy suck. However, they announced they offset <a href="https://artblocks.io/sustainability">7000 tons</a> of carbon, and will continue to offset more to remain sustainable. Thanks artblocks! Check out this guide on <a href="https://github.com/memo/eco-nft">eco-friendly NFTs.</a> Death to PoW. </p>
          <h4>Neural vs ByteBeat</h4>
          <p className="description">ByteBeat Synthesis is a lot like <a href="https://dadabots.com/science.php">Neural Synthesis.</a> They are both functions that generate a sequence of amplitudes. However Neural Synthesis is HUGE AF. One SampleRNN model is 700MB. Whereas ByteBeat functions are very short, usually under 1kb, sometimes just 32 characters. This makes them an ideal starting point for generative music synthesis where storage is scarce.</p>
          <p className="description">We are researching how to cross these two worlds. Simply training a character-level language model on the bytebeat function syntax is just the beginning. We aim to achieve an end-to-end differentiable audio-syntax model with a spectrogram loss, capable of audio2syntax, cramming incredible amounts of music into tiny spaces.</p>
        </div>
        }

        <div>
          {this.state.stage == "loading" && 
            <div>
              <img src="logo2.gif" className="noselect"/>
              <h2>{loadingText}</h2>
            </div>
          }
          
          {this.state.stage == "connected" && 
            <div>
              {bytebeatCode}
              <div className="timehex">t = {timeHex}</div>
              <div className="timecode">{timeText}</div>

              <TimeSlider seconds={this.bytebeat_engine.current_second} update_seconds={this.update_seconds.bind(this)}/>
            </div>
          }
          {this.state.canvases}

          {this.state.stage == "connected" && 
            <div className="thumbnails">
              {this.state.thumbnails}
            </div>
          }
          <div><button className="button">FREE PHYSICAL PERK<br/>for HOLDERS OF 4+<br/>12/12 AVAILABLE<br/>CHECK BACK MAY 1st</button></div>

        </div>
      </div>
    );
  }
}




export default App;
